<template>
  <div :class="[`detail-style-${detailStyle}`, opened ? 'opened' : 'closed']"
       @dblclick="toggleOpened"
  >
    <div v-if="editorType === 'markdown'"
         class="markdown-detail"
         @click="showEditor = true"
         v-html="parsedValue"
    ></div>
    <div v-else
         @click="showEditor = true"
         v-text="parsedValue"
    ></div>
    <Modal v-if="showEditor">
      <template #default>
        <pre v-text="modalValue" class="detail-inner"></pre>
      </template>
      <template #controls>
        <button class="asd-btn-cancel"
                @click="showEditor = false"
        >
          Zavřít
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import Modal from 'CORE/components/modal/modal'
import _ from 'lodash'
import marked from 'marked'

export default {
    name: 'LongTextDetail',
    components: {
        Modal,
    },
    mixins: [
        DataTypeProsMixin,
    ],
    data() {
        return {
            opened: false,
            showEditor: false,
        }
    },
    computed: {
        textareaRows() {
            return _.get(this.propertyType, 'settings.text_editor.editor_rows', '1')
        },
        editorType() {
            return _.get(this.propertyType, 'settings.text_editor.type', 'plaintext')
        },
        modalValue() {
            if (this.editorType === 'markdown') {
                return marked(this.value.value.value)
            } else {
                return this.value.value.value
            }
        },
        parsedValue() {
            if (this.editorType === 'markdown') {
                return marked(this.value.value.value)
            } else {
                const words = _.slice(_.words(this.value.value.value), 0, 10)
                return `${_.join(words, ' ')}...`
            }
        },
        detailStyle() {
            return _.get(this.propertyType, 'settings.text_editor.detail_style', 'minimal')
        },
    },
    methods: {
        toggleOpened() {
            this.opened = !this.opened
        },
    },
}
</script>

<style lang="scss" scoped>
    .detail-inner {
        white-space: break-spaces;
        line-height: 1.3rem;
        font-size: 1rem;
        text-align: left;
    }
    .markdown-detail {
        padding: 20px;
    }
    .detail-style {
        &-minimal {
            height: 1.3rem;
            overflow: hidden;
            &.closed {
                & > .markdown-detail {
                    padding: 0;
                }
            }
        }
        &-full {
            height: auto;
            overflow: scroll;
        }
        &-small {
            height: 10rem;
            overflow: scroll;
            &.closed {
                & > .markdown-detail {
                    padding: 0;
                }
            }
        }
    }
    .opened {
        height: auto !important;
    }
    .closed {
        cursor: pointer;
    }
</style>
